import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Button, Form, Message, Modal} from "semantic-ui-react";
import {formReceivedUserInput, submitLogin} from "../../LoginFromHomePageRequest/Actions";

export default class LoginFromHomePage extends Component {
    submitForm(e) {
        e.preventDefault();
        submitLogin(this.props.email, this.props.password)
    }

    render() {
        return (
            <Modal
                size='small'
                open={true}
                closeOnDimmerClick={true}
            >
                <Modal.Header>Sign In</Modal.Header>
                <Modal.Content>
                    <Form onSubmit={this.submitForm.bind(this)}
                          error={!!this.props.formErrorMessage}
                          success={!!this.props.formInfoMessage}
                          loading={this.props.formDisabled}>
                        <Form.Input label='Email' name='email' value={this.props.email}
                                    onChange={formReceivedUserInput}/>
                        <Form.Input type='password' label='Password' name='password' autoComplete='false'
                                    onChange={formReceivedUserInput}
                                    value={this.props.password}/>
                        <Message error content={this.props.formErrorMessage}/>
                        <Message success content={this.props.formInfoMessage}/>
                        <p>Don't have an account yet? Subscribe to our services in AWS <Link to="https://aws.amazon.com/marketplace/pp/B079VCQ2T8">here</Link>.
                        </p>
                        <Modal.Actions style={{textAlign: 'right'}}>
                            <Button primary type='submit'>Sign In</Button>
                        </Modal.Actions>
                    </Form>
                </Modal.Content>
            </Modal>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/shared_states/LoginFromHomePageRequest/components/LoginFromHomePageView.js
 **/